const loanAppraisalRoutes = [

    {

        name: 'loanAppraisalHome',
        path: '',
        component: () => import('./ListLoanAppraisal.vue'),
        meta: {
            auth: true,
            title: 'Loan Appraisal Listing',
            breadcrumb: 'Loan Appraisal Listing',
            permission: ['view loan-appraisal']
        }


    },
    {
        path: ':id/details',
        name: 'loanappraisaldetail',
        component: () => import('./LoanAppraisalDetail.vue'),
        meta: {
            auth: true,
            title: 'Loan Appraisal Details',
            breadcrumb: 'Loan Appraisal Details',
            permission: ['view loan-appraisal-detail']
        }
    },

];

export default loanAppraisalRoutes;
